import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: '15px',
  color: '#ffffff',
  fontSize: '13px',
  textTransform: 'none',
  backgroundColor: '#36899f',
  fontWeight: 'bold',
  padding: '15px',
  width: '100%',
  // height:"100%",
  '&:hover': {
    backgroundColor: '#36899f',
    boxShadow: 'none',
  },
  boxShadow: 'none',
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: '#ddb930',
  '&:hover': {
    backgroundColor: '#ddb930',
  },
}));

const YellowBigButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: '#ddb930',
  '&:hover': {
    backgroundColor: '#ddb930',
  },
}));

const GrayButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: '#3E3C4C',
  '&:hover': {
    backgroundColor: '#3E3C4C',
  },
}));
interface bigNormalButtonProps {
  color: string;
  text: string;
  size?: string;
  style?: Object;
  disabled?: boolean;
  onClick?: () => void;
}

const BigNormalButton: React.FC<bigNormalButtonProps> = ({
  color,
  text,
  size,
  style,
  disabled,
  onClick,
}) => {
  return color === 'sky' ? (
    <CustomButton
      onClick={onClick}
      variant="contained"
      style={style}
      disabled={disabled}
    >
      {text}
    </CustomButton>
  ) : color === 'yellow' ? (
    size === 'big' ? (
      <YellowBigButton
        onClick={onClick}
        variant="contained"
        style={style}
        disabled={disabled}
      >
        {text}
      </YellowBigButton>
    ) : (
      <YellowButton
        variant="contained"
        style={style}
        disabled={disabled}
        onClick={onClick}
      >
        {text}
      </YellowButton>
    )
  ) : (
    <GrayButton
      onClick={onClick}
      variant="contained"
      style={style}
      disabled={disabled}
    >
      {text}
    </GrayButton>
  );
};

export default BigNormalButton;
